import { Fragment } from "react";
import { Route } from "react-router-dom";

import MainLayout from "../layouts/webLayout/MainLayout";
import * as C from "./lazyComponents";

export const PublicRoutes = (
  <Fragment>
    <Route path="/login" element={<C.Login />} />
    <Route path={`${process.env.PUBLIC_URL}/application`} element={<C.Application />} />
    <Route path={`${process.env.PUBLIC_URL}/create-password/:token`} element={<C.Password />} />
    <Route element={<MainLayout />}>
      <Route path={`${process.env.PUBLIC_URL}/home`} element={<C.Home />} />
      <Route path={`${process.env.PUBLIC_URL}/how-to`} element={<C.About />} />
      <Route path={`${process.env.PUBLIC_URL}/verify-letter/:stateId/:batchNumber`} element={<C.VerifyLetter />} />
      <Route path={`${process.env.PUBLIC_URL}/verify-recommendation/:stateId/:batchNumber`} element={<C.VerifyRecommendation />} />
      <Route path={`${process.env.PUBLIC_URL}/contact`} element={<C.Contact />} />
      <Route path={`${process.env.PUBLIC_URL}/profile`} element={<C.UserProfile />} />
      <Route path={`${process.env.PUBLIC_URL}/payment/:token`} element={<C.InitiatePayment />} />
      <Route path={`${process.env.PUBLIC_URL}/payment-success`} element={<C.PaymentSuccess />} />
      <Route path={`${process.env.PUBLIC_URL}/track-status`} element={<C.StatusSearch />} />
    </Route>
  </Fragment>
);
